import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ComingSoon from './ComingSoon';
import Privacy from './pages/Privacy';
import About from './pages/About';
import Contact from './pages/Contact';
import Header from './components/Header';
import WhatsAppFab from './components/WhatsAppFab';
import ProtectedRoute from './components/ProtectedRoute';
import Account from './features/account/Account';
import DeleteAccount from './features/account/DeleteAccount';
import PurchasedEsimDetail from './features/account/PurchasedEsimDetail';
import Home from './features/home/Home';
import NotFound from './features/notfound/NotFound';
import EsimDetail from './features/home/EsimDetail';
import PlanDetail from './features/home/PlanDetail';
import UnlimitedDetail from './features/home/UnlimitedDetail';
import VoiceDetail from './features/home/VoiceDetail';
import HerculesPage from './features/home/HerculesPage';
import OrderSuccess from './features/order/OrderSuccess';
import OrderPending from './features/order/OrderPending';
import EsimGuide from './features/guide/EsimGuide';
import Checkout from './features/checkout/Checkout';
import Login from './features/auth/Login';
import Signup from './features/auth/Signup';
import VerifyEmail from './features/auth/VerifyEmail';
import ForgotPassword from './features/auth/ForgotPassword';
import { AuthProvider } from './context/AuthContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { isWebViewMode } from './utils/webviewUtils';
import i18n from './i18n';

// Sağdan sola yazılan diller
const RTL_LANGUAGES = ['ar', 'fa', 'ur'];

function App() {
  useEffect(() => {
    // WebView modunda body'ye class ekle
    if (isWebViewMode()) {
      document.body.classList.add('webview-mode');
    } else {
      document.body.classList.remove('webview-mode');
    }
  }, []);

  // Dil değişiminde <html> yön (dir) ve lang özniteliklerini güncelle (Arapça/Farsça/Urduca = RTL)
  useEffect(() => {
    const applyDirection = (lng) => {
      const code = (lng || i18n.language || 'tr').split('-')[0];
      document.documentElement.dir = RTL_LANGUAGES.includes(code) ? 'rtl' : 'ltr';
      document.documentElement.lang = code;
    };

    applyDirection(i18n.language);
    i18n.on('languageChanged', applyDirection);
    return () => i18n.off('languageChanged', applyDirection);
  }, []);

  return (
    <Router>
      {/* AuthProvider, Router İÇİNDE olmalı (useNavigate gerektirir) */}
      <AuthProvider>
       <CurrencyProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/esim/plan/:bundleId/:refillId" element={<PlanDetail />} />
          {/* Sınırsız ve ses paketleri ayrı ürün aileleridir (/v2/bundles);
              statik segment oldukları için /esim/:type/:id kalıbından önce
              eşleşirler. */}
          <Route path="/esim/unlimited/:bundleId" element={<UnlimitedDetail />} />
          <Route path="/esim/voice/:bundleId" element={<VoiceDetail />} />
          {/* Hercules (Avrupa'da sınırsız konuşma) kendi sayfasında durur;
              ses sekmesinde 37 tek-ülke paketinin arasında kayboluyordu. */}
          <Route path="/esim/hercules" element={<HerculesPage />} />
          <Route path="/esim/:type/:id" element={<EsimDetail />} />
          <Route path="/order/success" element={<OrderSuccess />} />
          {/* Ödeme sonrası asenkron provizyon bekleme ekranı — /my-esims'i
              yokladığı için oturum gerektirir. */}
          <Route
            path="/order/pending"
            element={
              <ProtectedRoute>
                <OrderPending />
              </ProtectedRoute>
            }
          />
          <Route path="/esim-guide" element={<EsimGuide />} />
          <Route
            path="/checkout"
            element={
              <ProtectedRoute>
                <Checkout />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account/esim/:orderId"
            element={
              <ProtectedRoute>
                <PurchasedEsimDetail />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          {/* Hesap silme: Google Play "Data deletion" şartı gereği oturum
              GEREKTİRMEZ (uygulamayı silmiş kullanıcı da erişebilmeli).
              İki URL aynı sayfa — Play Console'a İngilizce olan girilir. */}
          <Route path="/hesap-sil" element={<DeleteAccount />} />
          <Route path="/account-deletion" element={<DeleteAccount />} />
          {/* Eski koyu temalı sayfalar — global Header yerine kendi başlığını
              yalnızca bu route'larda render eder (yenilemede flash önlenir). */}
          <Route path="/soon" element={<><Header /><ComingSoon /></>} />
          <Route path="/privacy" element={<><Header /><Privacy /></>} />
          <Route path="/about" element={<><Header /><About /></>} />
          <Route path="/contact" element={<><Header /><Contact /></>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        {/* Her ekranda sağ-altta sabit WhatsApp destek butonu */}
        <WhatsAppFab />
       </CurrencyProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
